export default __webpack_public_path__ + "static/media/brief_1.22b42870.jpg";